<script setup>
import {computed, onUnmounted, getCurrentInstance, set, del} from 'vue'

const {proxy} = getCurrentInstance()
const store = proxy.$store
const route = proxy.$route

// --- Computed ---
const formData = computed(() => store.state.odpReports.formData)

// --- Created Logic ---
const month = route.query.month || ''
set(formData.value, 'month', month)

// --- Destroyed Logic ---
onUnmounted(() => {
    del(formData.value, 'month')
})
</script>

<template>
    <select
        required
        v-model="formData.month"
        class="form-select form-select-sm"
        name="month"
        oninvalid="this.setCustomValidity('Please select a month')"
        oninput="this.setCustomValidity('')"
    >
        <option value="">Month&hellip;</option>
        <option
            v-for="(month, index) in ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']"
            :key="index"
            :value="index + 1"
        >
            {{ month }}
        </option>
    </select>
</template>